<template>
    <b-container class="p-5">
        <b-row class="my-5">
            <b-col :sm="12" :md="3" class="my-2">
                <MultiselectDropdown
                    allLabel="All Time" 
                    :options="dateRangeList" 
                    :sideSingle="true"
                    :selectedName="this.queryMonths" 
                    @item-select="filterByPeriod" />
            </b-col>
            <b-col :sm="12" :md="3" class="my-2" v-if="merchantInitValue">
                <MultiselectDropdown
                    allLabel="All Merchants"
                    :options="merchantsList"
                    :hasMore="hasMoreMerchants"
                    :loadingMore="merchantsLoadingMore"
                    :searchResults="merchantsSearchResults"
                    :searchResultsLoading="merchantsSearchLoading"
                    :multiple="true"
                    :sideSingle="true"
                    :value.sync="this.merchantInitValue"
                    @item-select="filterByMerchants"
                    @load-more="loadMoreMerchants"
                    @search-input="onMerchantsSearchInput" />
            </b-col>
            <b-col :sm="12" :md="3" class="my-2">
                <MultiselectDropdown
                    allLabel="" 
                    :options="chartTypeList" 
                    :sideSingle="true" 
                    :selectedName="this.selectedChartType.name" 
                    @item-select="setChartType" />
            </b-col>
            <b-col :sm="12" :md="3" class="my-2">
                <MultiselectDropdown
                    allLabel="All Email Configs" 
                    :disabled="selectedMerchant?true:false"
                    :options="emailconfig ? emailconfig : []" 
                    :multiple="true" 
                    :sideSingle="true"
                    :value="this.queryEmailConfig" 
                    @item-select="setEmailConfig" />
            </b-col>
        </b-row>
        <div class="d-flex justify-content-center pb-4 mt-5" style="width: 100%; flex-wrap: wrap;">
            <graph-switch label_true="Count" label_false="Amount" @value.sync="isAmount"
                @change="value => chartVariations('CA', value)" />
            <graph-switch label_true="Regular" label_false="Cumulative" @value.sync="isCumulative"
                @change="value => chartVariations('RC', value)" />
            <graph-switch label_true="Value" label_false="Percent" @value.sync="isPercent"
                @change="value => chartVariations('VP', value)" />            
        </div>
        <div v-if="!isloading"
            class="d-flex justify-content-center mx-auto pb-4 pt-5" style="width: 100%;">
            <CohortChart :chartType="this.selectedChartType.id"
                :isPercent="isPercent" :isAmount="isAmount" :maxvalue="isAmount? maxAmount: maxCount"
                :series1="isAmount ? invoiceAmountDataMapped : invoiceCountDataMapped" :series2="rerminderData" />
        </div>
        <div v-else class="card card-custom shadow-none m-5">
            <div class="card-body p-0">
                <div class="blockui shadow-sm zindex-1">
                    <span class="btn spinner spinner-lg spinner-dark spinner-left">Loading...</span>
                </div>
            </div>
        </div>
    </b-container>
</template>
<script>
import { GET_ALL_MERCHANTS, LOAD_MORE_MERCHANTS, SEARCH_MERCHANTS, CLEAR_MERCHANTS_SEARCH, GET_ALL_MERCHANT_EMAIL_CONFIGS_LIST } from "@/store/monthlydata";
import { mapState } from 'vuex';
import { DateTime } from "luxon";
import { validateAdminQueryParameter } from "@/store/invoice/helpers";
import { QUERY_PARAMETERS_ACTIONS } from "@/store/queryparams";
import { getMonthYearsListfrom } from '@/dateRanges'
import MultiselectDropdown from "@/components/multiselect.dropdown.vue";
import CohortChart from "@/views/pages/cohortAnalysis/components/cohortChart.vue"
import GraphSwitch from "@/views/pages/cohortAnalysis/components/graphSwitch.vue"
import CohortAnalysisService from '@/services/cohortAnalysis';
export const chartTypeList = [
    {
        name: "Line",
        id: "line",
    },
    {
        name: "Column",
        id: "column",
    },
    {
        name: "Area",
        id: "area",
    },
];

export default {
    components: { MultiselectDropdown, CohortChart, GraphSwitch},
    data() {
        return {
            isloading: false,
            
            dateRangeList: getMonthYearsListfrom(),
            chartTypeList: chartTypeList,
            emailconfig: [],
            merchantInitValue: null,
            // Query Filters
            selectedMerchant: this.$route.query?.id?.split(",") ?? [],
            selectedPeriod: null,
            selectedEmailConfig: null,
            
            // Graph Controls
            isPercent: false,
            isAmount: false,
            isCumulative: false,
            selectedChartType: chartTypeList[0],


            // Query Params
            queryMonths: '',
            queryEmailConfig: null,
           
            // Graph Data
            invoiceCountData: [],
            invoiceAmountData: [],
            reminderDayData: [],
            maxAmount:0,
            maxCount:0,
            sumAmount:0,
            sumCount:0
        }
    },
    computed: {
        ...mapState({
            merchantsList: (state) => state.monthlydata.merchants,
            emailConfigsList: (state) => state.monthlydata?.emailConfigsList ?? null,
        }),
        hasMoreMerchants() {
            return !!this.$store.state.monthlydata.merchantsNextPageUrl;
        },
        merchantsLoadingMore() {
            return this.$store.state.monthlydata.merchantsLoadingMore;
        },
        merchantsSearchResults() {
            return this.$store.state.monthlydata.merchantsSearchResults || [];
        },
        merchantsSearchLoading() {
            return this.$store.state.monthlydata.merchantsSearchLoading;
        },
        rerminderData() {
            return this.reminderDayData.map((v)=>{
                let multiplyer = 1;
                if(this.isPercent){
                    multiplyer = 100;
                }else if(this.isAmount){
                    multiplyer = this.maxAmount;
                }else{
                    multiplyer = this.maxCount;
                }
                return {
                    x: v.x,
                    y: v.y * multiplyer
                }
            })
        },
        invoiceCountDataMapped:function(){
            if(this.isCumulative){
                return this.calculateCommulative(this.invoiceCountData)
            }
            return this.invoiceCountData.map((v)=>{
                let yval = v.y;
                if(this.isPercent){
                    yval = yval/this.sumCount * 100;
                }
                return {
                    x:v.x,
                    y:yval                
                }
            })
        },
        invoiceAmountDataMapped:function(){
            if(this.isCumulative){
                return this.calculateCommulative(this.invoiceAmountData)
            }
            return this.invoiceAmountData.map((v)=>{
                let yval = v.y;
                if(this.isPercent){
                    yval = yval/this.sumAmount * 100;
                }
                return {
                    x:v.x,
                    y:yval                
                }
            })
        },
    },
    mounted() {
        this.isloading = true;
        this.$store.dispatch(GET_ALL_MERCHANTS, { is_merchant: "True" })
            .then(()=>this.getQueryParams())
            .catch((message) => {
                this.error = "There was an error loading companies.";
            });
    },
    methods: {
        loadMoreMerchants() {
            this.$store.dispatch(LOAD_MORE_MERCHANTS);
        },
        onMerchantsSearchInput(term) {
            if (!term || !term.trim()) {
                this.$store.dispatch(CLEAR_MERCHANTS_SEARCH);
            } else {
                this.$store.dispatch(SEARCH_MERCHANTS, { search: term.trim(), is_merchant: 'True' });
            }
        },
        getQueryParams(){
            this.isloading = true
            this.queryEmailConfig =null;
            this.isAmount = this.$route.query.isAmount == 'true';
            this.isCumulative = this.$route.query.isCumulative == 'true';
            this.isPercent = this.$route.query.isPercent == 'true';
            
            this.selectedChartType = this.chartTypeList.find((obj)=> obj.id == this.$route.query.chart) ?? this.chartTypeList[0]
            

            if (this.$route.query.period) {
                let periodArray = this.$route.query.period;
                this.queryMonths = periodArray;
                this.selectedPeriod=[];
                let daterange = this.dateRangeList.find((obj)=> obj.id == periodArray)
                let period = {"start_date": daterange.value[0], "end_date": daterange.value[1]}
                this.selectedPeriod.push(period)
            } 
            this.merchantInitValue = [];
            if(this.$route.query.id){
                this.selectedMerchant = this.$route.query?.id?.split(",") ?? [];
                this.merchantInitValue = this.selectedMerchant;
                let config_list = this.$store.state.monthlydata.emailConfigsList
                for (let i = 0; i < this.selectedMerchant.length; i++) {
                    this.emailconfig= [...this.emailconfig, ...config_list.filter((obj) => obj.business_id == this.selectedMerchant[i])]
                }
                if(this.$route.query.email_config){
                    let emailArray = this.$route.query.email_config.split(",");
                    this.selectedEmailConfig =[];
                    this.queryEmailConfig = emailArray;
                    for (let i = 0; i < emailArray.length; i++) {
                        this.selectedEmailConfig=[...this.selectedEmailConfig,...config_list.filter((obj) => obj.id == emailArray[i])]
                    }
                }
                
            } 
            setTimeout(() => {
                this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.RESET_QUERY_PARAMS);
                this.getCohortAnalysis(); 
            }, 500);
        },
        filterByMerchants(eventip) {
            this.emailconfig = [];
            if (eventip == null || eventip.length == 0) {
                this.selectedMerchant = null;
                this.emailconfig = [];
                this.getCohortAnalysis();
            }
            else {
                let selected_ids = eventip.map((item) => item.id)
                this.selectedMerchant = selected_ids;
                for (let i = 0; i < selected_ids.length; i++) {
                    this.emailconfig.push(...this.emailConfigsList.filter((obj) => obj.business_id == selected_ids[i]))
                }
                this.getCohortAnalysis()
            }
        },
        filterByPeriod(eventip) {
            if (eventip == null || eventip.length == 0) {
                this.selectedPeriod = null;
                this.queryMonths = null;
                this.getCohortAnalysis();
            }
            else {
                this.queryMonths = eventip.map((obj)=> obj.id).join(',');
                this.selectedPeriod = { "start_date": eventip[0].value[0], "end_date": eventip[0].value[1] }
                this.getCohortAnalysis()
            }
        },
        getCohortAnalysis() {
            this.syncQueryParams();
            const payLoad = {
                id:this.selectedMerchant,
                email_config: this.selectedEmailConfig?.map((obj) => obj.id),
                ...(this.selectedPeriod ?? {}),
            }
            CohortAnalysisService.query(payLoad)
                .then(({ data }) => {
                    this.invoiceCountData = data.invoice_count;
                    this.invoiceAmountData = data.invoice_amount;
                    this.reminderDayData = data.reminder_days
                    this.maxAmount = parseInt(data.max_amount)
                    this.maxCount = data.max_count
                    this.sumAmount = this.invoiceAmountData.reduce((val, curr)=> val +curr.y, 0)
                    this.sumCount = this.invoiceCountData.reduce((val, curr)=> val +curr.y, 0)
                    if (data.invalid_invoices > 0) {
                        this.$showAlert(data.invalid_invoices + " invoices do not have paid date.", 'danger');
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.$showAlert("Something went wrong!", 'danger');
                })
                .finally(() => {
                    this.isloading = false;
                });
        },
        setChartType(evt) {
            this.selectedChartType = evt[0];
            let currentPath = this.$route.path;
            const payload = validateAdminQueryParameter({'chart':this.selectedChartType.id});
            this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.ADD_FILTER_QUERY_PARAMETER, {payload, currentPath})
        },
        setEmailConfig(evt) {
            this.selectedEmailConfig = evt; 
            this.queryEmailConfig = evt.map((obj)=> obj.id);
            this.getCohortAnalysis();
        },
        chartVariations(variant, value) {
            this.isloading = true;
            switch(variant){
                case 'CA':
                    this.isAmount = value
                    break;
                case 'RC':
                    this.isCumulative = value
                    break;
                case 'VP':
                    this.isPercent = value
                    break
            }
            this.syncQueryParams();
            this.isloading = false;
        },
        syncQueryParams(){
            const currentPath = this.$route.path;
            let payload = [];
            if(this.queryMonths){
                payload = [...payload, ...validateAdminQueryParameter({'period':this.queryMonths})];
            }
            if(this.selectedMerchant?.length){
                payload = [...payload, ...validateAdminQueryParameter({'id':this.selectedMerchant?.join(',')})];
            }
            if(this.queryEmailConfig?.length){
                payload = [...payload, ...validateAdminQueryParameter({'email_config':this.queryEmailConfig?.join(',')})];
            }
            if (this.selectedChartType.id) {
                payload = [...payload ,...validateAdminQueryParameter({'chart':this.selectedChartType.id})];
            }
            payload = [...payload, ...validateAdminQueryParameter({'isAmount':this.isAmount})];
            payload = [...payload, ...validateAdminQueryParameter({'isCumulative':this.isCumulative})];
            payload = [...payload, ...validateAdminQueryParameter({'isPercent':this.isPercent})];
            this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.ADD_FILTER_QUERY_PARAMETER, {payload, currentPath})
        },
        calculateCommulative(dataList){
            let commulativeValue = 0
            return dataList.map(
                (v)=>{
                    let yval = v.y
                    if(this.isPercent){
                        yval = v.y/(this.isAmount?this.sumAmount:this.sumCount)*100
                    }
                    commulativeValue = yval + commulativeValue
                    return {
                        x:v.x, 
                        y:commulativeValue
                    }
                }
            )
        },
    },
}
</script>
<style lang="scss">
@import './index.scss';
</style>
